module.exports = __webpack_public_path__ + "static/media/PMON-BUSD.6d9a9034.svg";